import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Root from './root';
import store from './store/';
import registerServiceWorker from './registerServiceWorker';

import 'sanitize.css/sanitize.css';
import './global-styles';

ReactDOM.render(
	<Provider store={store}>
		<Root />
	</Provider>,
	document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js